module.exports = __webpack_public_path__ + "static/group-313@2x-c5167b1c72bef3822175d900aee5ce5b.png";